import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import {RoleService} from "../services/role.service";
import {RoleList} from "../models/roleList";

@Injectable()
export class RolesResolve implements Resolve<RoleList> {
    constructor(private roleService: RoleService) {}

    resolve(route: ActivatedRouteSnapshot): Observable<RoleList> {
        return this.roleService.getAll();
    }
}
